import React from 'react'
import {
  Section,
  Placeholder,
  H3,
  ContainerLg,
  Lead
} from '../../GlobalStylesNew'
import { Row, Col } from 'reactstrap'
import { useStaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'
import { prop } from 'ramda'
import styled from 'styled-components'
import theme from '../../theme'

export const WelcomeSection = styled(Section)`
  background-color: ${p => p.theme.colors.navy};
  padding: 50px 0 20px;
  text-align: left;
  @media screen and (min-width: 768px) {
    padding: 100px 0 70px;
  }
  @media screen and (min-width: 1024px) {
    padding: 150px 0 120px;
  }
`

export const CardText = styled.div`
  padding: 30px 0;
  text-align: center;
  @media screen and (min-width: 768px) {
    text-align: left;
    * {
      text-align: left;
    }
  }
`

const Welcome = props => {
  const data = useStaticQuery(graphql`
    query {
      Tiles1: file(name: { eq: "GettyImages-157505473" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
      Tiles2: file(name: { eq: "20190724_PGA_kr_024 (1)" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
      Tiles3: file(name: { eq: "20190724_PGA_kr_009" }) {
        childCloudinaryAsset {
          fluid {
            ...CloudinaryAssetFluid
          }
        }
      }
    }
  `)
  return (
    <WelcomeSection id='features'>
      <ContainerLg>
        <Row>
          <Col md='4' xs='12'>
            {prop('Tiles1', data) ? (
              <Image fluid={data.Tiles1.childCloudinaryAsset.fluid} />
            ) : (
              <Placeholder />
            )}
            <CardText>
              <H3 color={theme.colors.white}>Maximize Potential</H3>
              <Lead color={theme.colors.white}>
                Let’s maximize each athlete’s potential; create well-rounded
                athletes and develop principles that create life-long golfers
                and athletes for generations. Your journey starts with PGA
                Coach.
              </Lead>
            </CardText>
          </Col>
          <Col md='4' xs='12'>
            {prop('Tiles2', data) ? (
              <Image fluid={data.Tiles2.childCloudinaryAsset.fluid} />
            ) : (
              <Placeholder />
            )}
            <CardText>
              <H3 color={theme.colors.white}>Lead from the Front</H3>
              <Lead color={theme.colors.white}>
                As a PGA Coach you can use the power of a profile and marketing
                on PGA.com to show the world who you are and why your students
                love to connect with you.
              </Lead>
            </CardText>
          </Col>
          <Col md='4' xs='12'>
            {prop('Tiles3', data) ? (
              <Image fluid={data.Tiles3.childCloudinaryAsset.fluid} />
            ) : (
              <Placeholder />
            )}
            <CardText>
              <H3 color={theme.colors.white}>Get Organized</H3>
              <Lead color={theme.colors.white}>
                {' '}
                With PGA Coach you now have the ability to run your coaching
                business in one place. Manage your students, calendar, bookings,
                and payments from anywhere with the PGA Coach app.{' '}
              </Lead>
            </CardText>
          </Col>
        </Row>
      </ContainerLg>
    </WelcomeSection>
  )
}

export default Welcome
